// 消息推送
export default {
    createTime: 'Creation Time',
    startTime: 'Start date',
    endTime: 'End date',
    to: 'to',
    title: 'Title',
    titleSeach: 'Title query',
    founder: 'Founder',
    pushModel: 'Push Mode',
    pushTime: 'Push Time',
    receiver: 'Receiver',
    priority: 'Priority',
    messageContent: 'Message Content',
    operate: 'Operate',
    detail:'Details',
    newMessagePush:' New message push',
    urgent: 'Urgent',
    high: 'High',
    middle: 'Middle',
    low: 'Low',
    single: 'Single',
    timing: 'Timing',
    cycle: 'Cycle',
    all:'All',
    names: 'Name',
    mobilePhone: 'Mobile Phone',
    sendTime: 'Send Time',
    interval: 'Interval',
    minute: 'Minute',
    messagePushDetails:' Message push details',
    pleaseEnter: 'please enter',
    plEnterTitle: 'Please enter a title',
    plenterMessageCount: 'Please enter the message content',
    selectPriority: 'Please select a priority',
    selectPushModel: 'Please select push mode',
    selectTime: 'Please select a time',
    selectInterval: 'Please select an interval',
    selectReceiver: 'Please select recipient',
    delOperate: 'Once the message is deleted, it cannot be recovered, please be careful!',
    select: 'Please choose',
    nameSeach: 'Name Query',
    addDepartment: 'Add Department',
    department: 'Department',
    license: 'License',
    name: 'Name',
    liceseType: 'License Type',
    personal: 'Personal',
    resetDepart: 'This department already exists! Please select another department',
    selectHasuserdepart: 'Please select a department with users',
}
